<template>
  <div>
    <!-- Título principal -->
    <h1 class="titulo-kpi">Kpi Admin</h1>

    <div v-if="!cargar" class="dashboard">
    <div class="card cambios">
      <h2>Cambios</h2>
      <p class="number">{{ totalCambios }}</p>
      <span class="label">Cambios faltantes</span>
      <RouterLink class="btn" to="/miscambios">Ir a vista</RouterLink>
    </div>

  <div class="card tickets">
    <h2>Tickets</h2>
    <p class="number">{{ ticketsPorAsignar }}</p>
    <span class="label">Tickets por asignar</span>
    <RouterLink class="btn" to="/tickets">Ir a vista</RouterLink>

    <div v-if="puedeDesbloqueoEmergencia" class="emergencia-box">
      <p class="emergencia-label">
        Bloqueo validación finanzas (usuario 28)
      </p>
      <p class="emergencia-meta">
        Pendientes &gt; 36 h: <strong>{{ estadoFinanzas.pendientes }}</strong>
        · Emergencia:
        <strong>{{ estadoFinanzas.desbloqueo_emergencia ? 'ACTIVA' : 'OFF' }}</strong>
      </p>
      <button
        type="button"
        class="btn btn-emergencia"
        :disabled="cargandoEmergencia"
        @click="toggleDesbloqueoEmergencia"
      >
        {{ estadoFinanzas.desbloqueo_emergencia
          ? 'Reactivar bloqueo'
          : 'Desbloqueo de emergencia' }}
      </button>
    </div>
  </div>

  <div class="card facturas">
    <h2>Facturas</h2>
    <p class="number">{{ factuasPendientes }}</p>
    <span class="label">Facturas pendientes</span>
    <RouterLink class="btn" to="/facturassolicitadas">Ir a vista</RouterLink>
  </div>
    </div>

    <carga                v-if="cargar"/>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import carga from '../../components/alertas/carga.vue'
import {
  puedeDesbloqueoEmergenciaFinanzas,
} from '@/utils/bloqueoValidacionFinanzas'
import validarErrores from '@/mixins/validarErrores'

export default {
  mixins: [validarErrores],
  components: {
    carga,
  },
  data: () => ({
    totalCambios: undefined,
    ticketsPorAsignar: 0,
    factuasPendientes: undefined,
    cargar: true,
    cargandoEmergencia: false,
    estadoFinanzas: {
      pendientes: 0,
      desbloqueo_emergencia: false,
      bloqueado: false,
    },
  }),
  computed: {
    ...mapGetters('login', ['getdatosUsuarioERPERP']),
    puedeDesbloqueoEmergencia() {
      return puedeDesbloqueoEmergenciaFinanzas(
        this.getdatosUsuarioERPERP && this.getdatosUsuarioERPERP.iderp
      )
    },
  },
  async mounted() {
    this.carga = true

    try {
      const resCambios = await this.$http.get('cambios.usuario.contador')
      this.totalCambios = resCambios.data.filter(d => d.estatus === 1).length

      const responseTickets = await this.$http.get('tickets.reporte.usuario')
      const listaFiltrada = responseTickets.data.filter(el => el.nombre_completo !== "Total" && ( el.Asignados > 0 || el.Pendiente > 0 || el.Revisión > 0 || el.Rechazados > 0 ) )

      listaFiltrada.map(d => {
        this.ticketsPorAsignar += +d.Asignados + +d.Pendiente + +d.Revisión + +d.Rechazados

      })

    const res = await this.$http.get('facturas.solicitadas')
    this.factuasPendientes = res.data.filter(el =>(!el.xml || !el.pdf) && el.aceptada != 2).length

    if (this.puedeDesbloqueoEmergencia) {
      await this.cargarEstadoFinanzas()
    }
    } catch (e) {
      console.error('Error al cargar datos:', e)
    } finally {
      this.cargar = false;
  }
},

  methods: {
    async cargarEstadoFinanzas() {
      try {
        const response = await this.$http.get('finanzas.bloqueo-validacion.estado')
        const data = response.data || {}
        this.estadoFinanzas = {
          pendientes: Number(data.pendientes) || 0,
          desbloqueo_emergencia: !!data.desbloqueo_emergencia,
          bloqueado: !!data.bloqueado,
        }
      } catch (error) {
        // Silencioso en carga inicial
      }
    },

    async toggleDesbloqueoEmergencia() {
      if (!this.puedeDesbloqueoEmergencia || this.cargandoEmergencia) return

      const activar = !this.estadoFinanzas.desbloqueo_emergencia
      const confirmar = window.confirm(
        activar
          ? '¿Activar desbloqueo de emergencia para admin_finanzas (usuario 28)?'
          : '¿Reactivar el bloqueo por validación de ingresos?'
      )
      if (!confirmar) return

      this.cargandoEmergencia = true
      try {
        const response = await this.$http.post(
          'finanzas.bloqueo-validacion.desbloqueo-emergencia',
          {
            activo: activar ? 1 : 0,
            motivo: activar
              ? 'Desbloqueo de emergencia desde KPI Admin / tickets'
              : 'Reactivación de bloqueo desde KPI Admin / tickets',
          }
        )
        const data = (response.data && response.data.data) || response.data || {}
        this.estadoFinanzas = {
          pendientes: Number(data.pendientes) || 0,
          desbloqueo_emergencia: !!data.desbloqueo_emergencia,
          bloqueado: !!data.bloqueado,
        }
        this.validarSuccess(
          activar
            ? 'Desbloqueo de emergencia activado'
            : 'Bloqueo reactivado'
        )
      } catch (error) {
        let msg = 'No se pudo actualizar el desbloqueo de emergencia'
        if (error && error.response && error.response.data && error.response.data.message) {
          msg = error.response.data.message
        }
        this.validarError(msg)
      } finally {
        this.cargandoEmergencia = false
      }
    },
  },
}
</script>

<style scoped>

.titulo-kpi {
  margin-top: 2rem;
  font-size: 2rem;
  font-weight: 600;
  color: #374151; /* parecido a Tailwind text-gray-700 */
  margin-bottom: 1.5rem;
  text-align: center;
}

.btn {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  width: fit-content;
  background-color: #007BFF;
  border-radius: 8px;
  color: white;
  text-decoration: none;
  align-self: center;
  margin-top: 0.7rem;
  border: none;
  cursor: pointer;
  display: inline-block;
}
/* Contenedor principal */
.dashboard {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
  margin: 40px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

/* Tarjeta individual */
.card {
  display: flex;
  flex-direction: column;
  flex: 1 1 250px;
  max-width: 300px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  padding: 20px;
  text-align: center;
  transition: transform 0.2s, box-shadow 0.2s;
}

.card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 20px rgba(0,0,0,0.15);
}

.card h2 {
  margin: 0 0 10px;
  font-size: 1.25rem;
  color: #333;
}

.number {
  font-size: 2.5rem;
  font-weight: 700;
  margin: 0;
  color: #111827;
}

.label {
  color: #6b7280;
  font-size: 0.9rem;
}

.tickets .number { color: #2563eb; }
.cambios .number { color: #d97706; }
.facturas .number { color: #059669; }

.emergencia-box {
  margin-top: 1rem;
  padding-top: 0.75rem;
  border-top: 1px solid #e5e7eb;
  text-align: center;
}

.emergencia-label {
  margin: 0;
  font-size: 0.8rem;
  font-weight: 600;
  color: #991b1b;
}

.emergencia-meta {
  margin: 0.35rem 0 0;
  font-size: 0.75rem;
  color: #6b7280;
}

.btn-emergencia {
  background-color: #dc2626;
  margin-top: 0.6rem;
}

.btn-emergencia:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
